module.exports = __webpack_public_path__ + "static/media/branding.55937379.jpg";